import CustomInput from "../../eventcreation/components/CustomInput";
import { makeStyles } from "@mui/styles";
// import { customTheme as theme } from "../../../theme/customTheme";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FocusTrap from "@mui/base/FocusTrap";
import useValidator from "../../../hooks/useValidator";
import { userResetPassword } from "../../../services/api";
import { afterValidate, setInput } from "../../../utils/commonServices";
import { updateState } from "../../../redux/commonSlice";
// import ForgotPasswordPopup from "./ForgotPasswordPopup";
import useAuthRequest from "../../../hooks/useAuthRequest";
// import EmailVerificationPopup from "./EmailVerificationPopup";
// import CustomSnackbar from "../../components/CustomSnackbar";
// import CustomSnackbarDrawer from "../../components/CustomSnackbarDrawer";
import movieIcon from '../../../assets/movieIcon.svg';
import { Box, Grid, Paper, Typography } from '@mui/material';
import UnauthLayout from '../components/UnauthLayout'
import CustomButton from "../../../components/CustomButton";
import { LoadingButton } from "@mui/lab";
import CustomTooltip from "../../../components/CustomTooltip";
import PasswordInstructions from "../../../components/PasswordInstructions";
import ResetSuccessPopup from "./components/ResetSuccessPopup";
import useCustomTheme from "../../../theme/useCustomTheme";
import useUnauthActions from "../useUnauthActions";


const useStyles = makeStyles((theme) => ({
  center: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "start",
    minHeight: "100%",
  },
}));

const ResetPassword = () => {

  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const token = query.get('reset_password_token')

  const classes = useStyles();
  const [theme] = useCustomTheme()
  const [pageData, setPageData] = useState({
    password: "",
    password_confirmation: ""
  });

  const [openSuccessPopup, setOpenSuccessPopup] = useState(false);
  const [isTokenValid, setIsTokenValid] = useState(false)
  const [snackbarProps, setSnackbarProps] = useState({});
  const { checkResetPasswordTokenValidity, resetPassword } = useUnauthActions();
  const pendingCallReducer = useSelector((state) => state.pendingCallReducer)
  const [errorObjectArray, checkEmptyFields, checkValue] = useValidator(pageData);
console.log({token})
  useEffect(() => {
    if(!!token)
    checkResetPasswordTokenValidity({ reset_password_token: token }, setIsTokenValid);

  }, [token])

  const submitClickHandler = (event) => {

    checkValue(event);
    checkEmptyFields(event);
    // setPageData({password:'',password_confirmation:''})

    afterValidate(afterValidatCallback);
  }

  const afterValidatCallback =  () => {
   resetPassword({...pageData, "reset_password_token": token}, setOpenSuccessPopup)

    // dispatch(updateState({
    //     is_logged: true
    // }));
    // navigate('/');

  }

  // useEffect(()=> {

  //   if(resetPasswordStatus == "success") {
  //     setOpenSuccessPopup(true);
  //    }
  // }, [resetPasswordStatus])

  //code to detect enter key for editing Organization Name
  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        submitClickHandler(event);


      }
    };
    document.addEventListener('keydown', keyDownHandler);

    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [pageData]);

  return (<UnauthLayout both >
        {
          pendingCallReducer?.checkResetTokenValidity ? <Grid container justifyContent="center" spacing={4} >
          <Grid item xs={11} sm={8} md={7} >
            <Box>
              <Typography variant="h6" style={{ fontFamily: 'Rubik', color: 'black', fontWeight: theme.typography.fontWeightBold, textAlign: 'center' }}>
                VERIFYING LINK...
              </Typography>
            </Box>
          </Grid>
        </Grid> : isTokenValid ? <Box className={classes.center} square component="Box">

            <Box container justifyContent="flex-start" spacing={3}>
              <Box item xs={11} sm={8} md={7}>
                <Box sx={{ marginY: { xs: '15px', md: '20px', lg: '25px', xl: '38px' } }}>
                  <Typography
                    variant="h4"
                    color="primary"
                    style={{
                      fontWeight: 600,
                      color: '#08231B'
                    }}
                    sx={{ fontSize: { xs: '30px', sm: '40px', md: '47px', lg: '54px', xl: '80px' }, fontFamily: 'Rubik' }}
                  >
                    Reset Password
                  </Typography>
                </Box>
              </Box>

              <Box item xs={11} sm={8} md={7} gap={0.8} sx={{ display: 'flex', flexDirection: 'column', }}>
                <CustomTooltip
                  arrow
                  enterTouchDelay={0}
                  leaveTouchDelay={5000}
                  title={<PasswordInstructions />}
                  placement={window.innerWidth <= 1100 ? 'bottom' : 'right'}
                  PopperProps={{
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: window.innerWidth >= 1100 && [0, 40],
                        },
                      },
                    ],
                  }}
                >

                  <CustomInput
                    id={errorObjectArray[0]?.id}
                    onFocus={checkEmptyFields}
                    onBlur={checkValue}
                    required
                    // bottom ={errorObjectArray[0]?.error != "Please enter password" && -22}
                    errorFlag={errorObjectArray[0]?.errorFlag}
                    errorMsg={errorObjectArray[0]?.error}
                    //label="New Password*"
                    type="password"
                    max={40}
                    placeholder="New Password*"
                    onChange={(event) => setInput(pageData?.password != "" ? event.target.value : event.target.value.trim(), "password", pageData, setPageData)}
                    value={pageData?.password}
                  // sx={{ marginBottom: "1rem" }}        
                  />

                </CustomTooltip>
                <CustomInput
                  id={errorObjectArray[1]?.id}
                  onFocus={checkEmptyFields}
                  onBlur={checkValue}
                  required
                  errorFlag={errorObjectArray[1]?.errorFlag}
                  errorMsg={errorObjectArray[1]?.error}
                  // label="Confirm Password*"
                  type="password"
                  max={40}
                  placeholder="Confirm Password*"
                  onChange={(event) => setInput(pageData?.password_confirmation != "" ? event.target.value : event.target.value.trim(), "password_confirmation", pageData, setPageData)}
                  value={pageData?.password_confirmation}
                // sx={{ marginBottom: "1rem" }}  
                />

              </Box>

              <Box item xs={11} sm={8} md={7}>
                <Box
                  container
                  justifyContent="space-between"
                  sx={{
                    flexDirection: { xs: "column-reverse", sm: "row" },
                    alignItems: "center",
                    paddingTop: 0,
                  }}
                >

                  <Box item xs={8} sm={4} sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: { xs: '20px', sm: '28px', md: '28px', lg: '33px', xl: '50px' } }}>
                    {/* <CustomButton
                      disabled={ResetPasswordStatus == "loading"}
                      btnText="Login"
                      variant="contained"
                      color="primary"
                      size="medium"
                      onClick={submitClickHandler}
                      style={{borderRadius: '5px', backgroundColor:'#08231B', color:theme.palette.primary.main, textTransform:'none', }} 
                      sx={{height:{xs:'18px',sm:'20px',md:'22px', lg:'23px', xl:'35px'}, width:{xs:'70px', lg:'90px',xl:'129px'}, fontSize:{xs:'10px',md:'10px',lg:'11px',xl:'16px'}, fontFamily:'Rubik', fontWeight:600,}}
                    /> */}
                    <LoadingButton
                      // size="small"
                       disabled={pendingCallReducer.resetPassword}
                      onClick={submitClickHandler}
                      style={{ borderRadius: '5px', backgroundColor: '#08231B', color: '#21D644', textTransform: 'none', }}
                      sx={{ height: { xs: '18px', sm: '20px', md: '22px', lg: '23px', xl: '35px' }, width: { xs: '70px', lg: '90px', xl: '129px' }, fontSize: { xs: '10px', md: '10px', lg: '11px', xl: '16px' }, fontFamily: 'Rubik', fontWeight: 600, minWidth: '94px !important' }}
                      // sx={{ fontSize:{xs:'9px',sm:'9px',md:'9px',lg:'11px',xl:'16px', },fontWeight:600, width:{xs:'76px',sm:'76px',md:'76px',lg:'86px',xl:'129px'},  opacity: !checked && 0.7, minWidth: '110px !important'}}
                      loading={pendingCallReducer.resetPassword}
                      loadingPosition="start"
                      // loading = {true}
                      variant="contained"
                    >
                      Submit
                    </LoadingButton>
                  </Box>

                </Box>
              </Box>
            </Box>


          </Box> : <Grid container justifyContent="center" spacing={4} >
            <Grid item xs={11} sm={8} md={7} >
              <Box>
                <Typography variant="h6"  style={{ fontFamily: 'Rubik', color: 'black', fontWeight: theme.typography.fontWeightBold, textAlign: 'center' }}>
                  The reset password link seems invalid. Please go to <span ><Link to="/forgotpassword" style={{ color: 'blue' }} > Forgot Password</Link></span> to generate a new link.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        }

        {openSuccessPopup &&
          <ResetSuccessPopup
            openHandler={openSuccessPopup}
            closeHandler={setOpenSuccessPopup}
          />
        }

      </UnauthLayout>
  )
}

export default ResetPassword
